/** 头部导航栏 */
import './index.scss'
import React from 'react';
import { connect } from 'react-redux'
import {Select, Menu, Dropdown} from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  DownOutlined
} from '@ant-design/icons';
import pub from "../../lib/public";
import BreadcrumbTop from "../breadcrumb/index";
const { Option } = Select;

class header extends React.Component{
  handleMenuClick = e => {
    if (e.key === 'loginOut') {
      pub.removeCookie("SID");
      sessionStorage.clear();
      localStorage.clear();
      window.location = this.props.userInfo.logoutUrl;
    }
  };
  render() {
    const { sysVal, sysList, name } = this.props;
    const menu = (
      <Menu onClick={e => this.handleMenuClick(e)}>
        <Menu.Item key="loginOut">退出</Menu.Item>
      </Menu>
    );
    return (
      <div className="header-page-top" style={{ left: this.props.collapsed ? 80 : 220 }}>
        <span className="menu-btn" onClick={this.props.toggleCollapsed} >
          {this.props.collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </span>
        <BreadcrumbTop routeData={this.props.routeData}></BreadcrumbTop>
        <div className='page-top-right cursor'>
          <Select value={sysVal} style={{ width: 160 }} onChange={this.props.sysValChange}>
            {sysList.map(item => {
              return <Option key={item.id} value={item.id}>{item.name}</Option>
            })}
          </Select>
          <Dropdown overlay={menu} placement="bottomRight">
            <span className="ant-dropdown-link">
              {name} <DownOutlined />
            </span>
          </Dropdown>
        </div>
      </div>
    );
  }
};

// storeState：将state映射到组件的props中
const storeState = (state) => {
  return {
    userInfo: state.setUserInfo
  }
};
export default connect(storeState)(header);
